import React, { Component } from 'react';
import { connect } from 'react-redux';
import Head from '../../views/app/Head';
import { appActions } from '../../store/modules/app';

class HeadContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: null,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.listenScrollEvent);
  }

  listenScrollEvent = () => {
    if (window.scrollY > 10) {
      this.setState({ color: 'white' });
    } else {
      this.setState({ color: null });
    }
  };

  render() {
    const { isCollapsed, logout, sidebarToggleCollapse, adminInfo } = this.props;
    const { color } = this.state;

    return (
      <Head
        isCollapsed={isCollapsed}
        adminInfo={adminInfo}
        color={color}
        onLogout={logout}
        sidebarToggleCollapse={sidebarToggleCollapse}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isCollapsed: state.app.sidebar.isCollapsed,
    adminInfo: state.app.adminInfo,
  };
};

const mapDispatchToProps = {
  sidebarToggleCollapse: appActions.sidebarToggleCollapse,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeadContainer);
